import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { convertToLocalWallClockTime } from "../../../utility/timezoneUtils";
import { useUserPreferences } from "../../../hooks/useUserPreferences";
const DateTimePicker = ({ label, onChange, defaultSelected, timeZoneId, is12HourClock: providedIs12HourClock, primaryColor, themeMode }) => {
  const { is12HourClock: userIs12HourClock } = useUserPreferences();
  const is12HourClock = providedIs12HourClock !== undefined ? providedIs12HourClock : userIs12HourClock;

  // Convert the appointment time to show the same wall-clock time in local timezone
  const getInitialDate = () => {
    if (!defaultSelected) return new Date();
    return convertToLocalWallClockTime(defaultSelected, timeZoneId);
  };

  const [selectedDate, setSelectedDate] = useState(getInitialDate());

  const onChangeHandler = (date) => {
    setSelectedDate(date);
    // Include timezone information with the date
    const dateWithTimezone = {
      date: date,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    onChange(dateWithTimezone);
  };

  return (
    <div>
      <label
        htmlFor="datetime"
        className="block text-sm/6 font-medium text-themed-primary"
      >
        {label}
      </label>
      <div className="mt-2">
        <DatePicker
          id="datetime"
          selected={selectedDate}
          onChange={onChangeHandler}
          showTimeSelect
          dateFormat={is12HourClock ? "Pp" : "P HH:mm"}
          timeFormat={is12HourClock ? "p" : "HH:mm"}
          timeIntervals={15}
          timeCaption="Time"
          placeholderText="Select date and time"
          wrapperClassName="w-full"
          className="block w-full rounded-md bg-themed-card px-3 py-1.5 text-base text-themed-primary outline outline-1 -outline-offset-1 outline-ink-200 placeholder:text-themed-secondary focus-themed sm:text-sm/6"
        />
      </div>
    </div>
  );
};

export default DateTimePicker;
